import React from 'react';
import { connect } from 'react-redux';

import CardContainer from './CardContainer';

import { getPlaceThemes } from '../../../redux/actions/placeActions';
import { openThemesModalAndSetSlideIndex } from '../../../redux/actions/placesModalActions';
import {
  setLimtAndPage,
  setThemeCategories,
  setSearchTerm,
  clearThemeConfigs,
  refreshThemeData,
} from '../../../redux/actions/selectedPlaceActions';

// selector
import { getSortedThemes } from '../../../redux/selectors/PlacesThemeSorters';
// import { editDayCard } from "../../../redux/actions/patchToDay";
import { limitForDay } from '../../../constants/limits';

const EntityContainer = props => <CardContainer {...props} />;

const mapStateToProps = (state, ownProps) => {
  const { placeId, placeName, theme } = ownProps;
  const { limit, page, categories, searchTerm } = state.selectedPlace[theme];
  const isLastPage = state.selectedPlace[theme].isLastPage;
  const slideIndex = state.placesModal.slideIndex;
  return {
    limit,
    page,
    categories,
    searchTerm,
    themesArray: getSortedThemes(state, { placeId, placeName, theme }),
    isLastPage,
    slideIndex,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { placeId, placeName, theme } = ownProps;
  return {
    getPlaceThemes: async ({ limit, page, categories, searchTerm }) => {
      dispatch(setLimtAndPage({ limit, page, theme }));

      const data = await dispatch(
        getPlaceThemes({
          placeName,
          placeId,
          theme,
          limit: limitForDay,
          page,
          categories,
          searchTerm,
        })
      );
      return { data };
    },
    openSlider: ({ slideIndex }) => {
      dispatch(openThemesModalAndSetSlideIndex({ slideIndex, themeType: theme }));
    },
    getPlaceThemesByCategories: async ({ limit, page, categories, searchTerm }) => {
      dispatch(setThemeCategories({ categories, theme }));
      dispatch(
        getPlaceThemes({
          placeName,
          placeId,
          theme,
          limit: limitForDay,
          page,
          categories,
          searchTerm,
        })
      );
    },
    getCardsBySearchTerm: async ({ searchTerm, limit, page, categories }) => {
      dispatch(setSearchTerm({ searchTerm, theme }));
      dispatch(
        getPlaceThemes({
          placeName,
          placeId,
          theme,
          limit: limitForDay,
          page,
          categories,
          searchTerm,
        })
      );
    },
    setLimitAndPage: ({ limit, page }) => {
      dispatch(setLimtAndPage({ limit, page, theme }));
    },
    clearThemeConfigs: () => {
      dispatch(clearThemeConfigs({ theme }));
    },
    refreshThemeData: () => {
      dispatch(refreshThemeData({ theme, placeId }));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EntityContainer);



// WEBPACK FOOTER //
// ./src/screens/Trek/ServiceModal/EntityContainer.js